import { useEffect, useState } from 'preact/hooks';
import { AppContext, type AppEnv } from './app-context';
import { NotebookList } from './NotebookList';
import { NotebookView } from './NotebookView';
import { PersistBanner } from './PersistBanner';
import { Settings } from './Settings';

type Route = { name: 'list' } | { name: 'notebook'; id: string } | { name: 'settings' };

function parseRoute(hash: string): Route {
  const nb = /^#\/nb\/([\w-]+)/.exec(hash);
  if (nb) return { name: 'notebook', id: nb[1]! };
  if (hash.startsWith('#/settings')) return { name: 'settings' };
  return { name: 'list' };
}

export function App({ env }: { env: AppEnv }) {
  const [route, setRoute] = useState(() => parseRoute(location.hash));
  useEffect(() => {
    const on = () => setRoute(parseRoute(location.hash));
    addEventListener('hashchange', on);
    return () => removeEventListener('hashchange', on);
  }, []);

  return (
    <AppContext.Provider value={env}>
      <PersistBanner />
      {env.recovered > 0 && <div class="banner ok">Recovered {env.recovered} unsaved stroke(s) from the last session.</div>}
      {route.name === 'list' && <NotebookList />}
      {route.name === 'notebook' && <NotebookView id={route.id} />}
      {route.name === 'settings' && <Settings />}
    </AppContext.Provider>
  );
}
